
import { Component, mixins } from 'nuxt-property-decorator';
import { LegacyTextBlockModel } from 'fourwaves-shared';
import { RawHtml } from 'fourwaves-shared/components';
import ContentBlockMixin from '../ContentBlockMixin';

@Component({
  components: {
    RawHtml,
  },
})
export default class LegacyTextBlock extends mixins(ContentBlockMixin<LegacyTextBlockModel>) {}
